export const colorSchemeSwitcher = () => {
    const STORAGE_KEY = "colorScheme";
    const COLOR_SCHEME_PICKER = document.getElementById("color-scheme-switcher");

    const getSystemColorSchemeSetting = () =>
        window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";

    const getColorSchemePreference = () => {
        if (localStorage.getItem(STORAGE_KEY)) {
            return localStorage.getItem(STORAGE_KEY);
        } else {
            localStorage.setItem(STORAGE_KEY, getSystemColorSchemeSetting());
            return getSystemColorSchemeSetting();
        }
    };

    const setColorSchemePreference = event => {
        if (event) {
            localStorage.setItem(STORAGE_KEY, event?.target?.value || localStorage.getItem(STORAGE_KEY));
            color_scheme.value = event?.target?.value || localStorage.getItem(STORAGE_KEY);
        } else {
            localStorage.setItem(STORAGE_KEY, color_scheme.value);
        }
        reflectColorSchemePreference();
    };

    const reflectColorSchemePreference = () => {
        document.documentElement.setAttribute("data-color-scheme", color_scheme.value);
        COLOR_SCHEME_PICKER.value = color_scheme.value;
    };

    const color_scheme = {
        value: getColorSchemePreference()
    };

    const syncWithSystem = () => {
        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", ({ matches: isDark }) => {
            color_scheme.value = isDark ? "dark" : "light";
            setColorSchemePreference();
        });
    };
    reflectColorSchemePreference();

    COLOR_SCHEME_PICKER.addEventListener("change", setColorSchemePreference);

    syncWithSystem();
};
